import { Heading, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';

export function NewExchange() {
  return (
    <S.Wrapper>
      <S.TextWrapper>
        <Heading as="h1" weight={FontWeight.bold}>
          Devoluções de pedidos
        </Heading>

        <Text size={FontSize.font12}>
          Busque pelo pedido que será devolvido e preencha o formulário para
          solicitar a devolução. Caso o cliente deseje efetuar uma troca, inicie
          a solicitação pelo menu lateral.
        </Text>
      </S.TextWrapper>
    </S.Wrapper>
  );
}
